<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <backHomeBanner-component />
    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import backHomeBannerComponent from '../backHome/backHomeBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'homeComponent',
  components: {
    headerComponent,
    backHomeBannerComponent,
    footerComponent,
  },
};
</script>
